export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11896.1014bc6d.jpg";